export enum ProofType {
  payment,
  incomeTax,
  vatTax,
}
